@if (companyLifeState$ | async; as state) {
  @if (!state.healthy && state.mainStateKey) {
    <span class="badge badge-{{ colorClasses[state.mainStateKey] }}">
      {{ 'company.company_life_state.' + state.mainStateKey | translate }}
      @if (state.mainState?.company_state_timeline?.active_from_date; as fromDate) {
        <em><strong>{{ fromDate | date: dateFormats.Standard }}</strong></em>
      }
    </span>
  }
}
